import {Pipe, PipeTransform} from '@angular/core';
import {UnitProductDto} from '../../Models/Purchases/Products/unit-product.interface';

@Pipe({
  name: 'units',
  standalone: false,
})
export class UnitsPipe implements PipeTransform {

  transform(items: UnitProductDto[], filters?: {sameTypeAs?: number, symbols?: string[]}): UnitProductDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (!filters) {
      return items;
    }

    if (filters.sameTypeAs) {
      const targetUnit = items.find((unit) => unit.id === filters.sameTypeAs);

      if (targetUnit) {
        items = items.filter((unit) => unit.tipo === targetUnit.tipo);
      }
    }

    if (filters.symbols && filters.symbols.length > 0) {
      items = items.filter((unit) => filters.symbols!.includes(unit.simbolo));
    }

    return items;
  }

}
